import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const VideoCallIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg width="24" height="24" fill="none" ref={ref} {...props}>
    <g clipPath="url(#clip0_723_436)" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2.246 5.626h12.002a3 3 0 0 1 3 3v9.002a.75.75 0 0 1-.75.75H4.498a3 3 0 0 1-3-3V6.376a.75.75 0 0 1 .75-.75v0ZM17.249 10.502l5.25-3v9l-5.25-3" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(-.004)" d="M0 0h24.004v24.004H0z" />
      </clipPath>
    </defs>
  </svg>);
export default VideoCallIcon;